import React from 'react';
import { MultiSelectDropdown, useToasts } from 'freemium-ui';
import { useTranslation } from 'react-i18next';
import { WorkflowType } from 'shared/types';

type TriggerWorkflowActionProps = {
  handleFilterChange: (value: any) => void;
  selectedItems: any[];
  setSelectedItems: (value: any[]) => void;
  workflowList: any;
  isWorkflowsLoading: boolean;
};

function TriggerWorkflowAction(props: TriggerWorkflowActionProps) {
  const {
    handleFilterChange,
    selectedItems,
    workflowList,
    setSelectedItems,
    isWorkflowsLoading,
  } = props;

  const [, setToast] = useToasts();
  const { t } = useTranslation();

  const handleChange = (values: WorkflowType[], isCustomValueAdded = false) => {
    if (isCustomValueAdded) {
      setToast({
        delay: 2000,
        type: 'error',
        text: `${t('forms.toast.error.workflow_not_exist')}`,
      });
    } else {
      setSelectedItems(values);
    }
  };

  return (
    <MultiSelectDropdown
      name="trigger-workflow-action"
      items={workflowList || []}
      selectedItem={selectedItems}
      onChange={handleChange}
      isMenuLoading={isWorkflowsLoading}
      itemLabelIdentifier="name"
      itemValueIdentifier="name"
      customValues
      onCustomValueAdd={(items) => {
        handleChange(items, true);
      }}
      placeholder={selectedItems.length ? '' : 'Enter 2 letters...'}
      handleInputChange={handleFilterChange}
      isDynamicMenu
    />
  );
}

export default TriggerWorkflowAction;
